import { render } from "./App.vue?vue&type=template&id=1d73041a"
const script = {}

import exportComponent from "/Volumes/my/猫嗅笔记相关项目/猫嗅笔记管理后台/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__